const red = {
  100: '#F5EAEA',
  // background > warning
  light: '#E68080',
  main: '#CC0000',
  500: '#CC0000',
  600: '#A30000',
  dark: '#870007' // !! Color Text > tertiary > red(700) > #993131
};

export default red;